import {configureStore} from "@reduxjs/toolkit";

// Import des reducers directement (pas des slices entiers)
import sitesReducer from "./features/sites/sitesSlice.js";
import authReducer from "./features/authSlice.js";
import uiReducer from "./features/uiSlice.js";
import visiteReducer from "./features/visiteSlice.js";

export const store = configureStore({
    reducer: {
        sites: sitesReducer,
        auth: authReducer,
        ui: uiReducer,
        visitors: visiteReducer,
        visites: visiteReducer,
    },
});